<template>
    <div class="eda-reset">

        <template v-if="checkingHash">
            <eda-ellipsis-loader></eda-ellipsis-loader>
        </template>
        <template v-else-if="validHash">

            <h1 class="eda-reset__heading">
                Velg nytt passord
            </h1>

            <div class="eda-reset__description">
                Minst seks tegn.
            </div>

            <div class="eda-reset__password">
                <eda-text-input :darkTheme="true" v-model="password" type="password"
                                label="Nytt passord"
                                placeholder="Nytt passord">

                </eda-text-input>
            </div>

            <div class="eda-reset__submit">
                <eda-button class="eda-reset__button"
                            @click="resetPassword()"
                            label="Lagre"
                            :disabled="!passwordValid"
                            :hide-disabled="true"
                            :error="error"
                            :loading="sendingRequest"></eda-button>
            </div>

        </template>
        <template v-else>
            <h1 class="eda-reset__heading">
                Lenken for å tilbakestille passordet er ikke gyldig.
            </h1>
            <div class="eda-reset__description">
                Merk at lenken kun er gyldig i 30 minutter etter at den blir generert.
            </div>

            <div class="eda-reset__retry">
                <eda-link to="/user/recover"> Prøv på nytt</eda-link>
            </div>
        </template>

    </div>
</template>

<script>
    import axios from 'axios';
    import EdaButton from "../components/vButton"
    import EdaLink from "../components/vLink"
    import EdaTextInput from "../components/vInput"
    import {mapActions} from 'vuex';
    import EdaEllipsisLoader from "../components/vEllipsisLoader";
    import api from "../mixins/apiMixin.js"


    export default {
        name: "eda-reset",
        components: {
            EdaEllipsisLoader,
            EdaButton,
            EdaTextInput,
            EdaLink
        },
        mixins: [api.apiMixin],
        props: {
            hash: {type: String, default: ""}
        },
        data: function () {
            return {
                error: false,
                password: "",
                success: false,
                sendingRequest: false,
                validHash: null,
                checkingHash: false,
            }
        },
        mounted() {
            this.checkHash();

        },
        computed: {
            passwordValid() {
                return this.password.length >= 6;
            }

        },
        methods: {
            ...mapActions([
                "setUser"
            ]),
            checkHash() {
                var that = this;
                that.checkingHash = true;
                axios.get(process.env.VUE_APP_API_URL +"/users/reset/" + that.hash,
                    that.apiHeaders
                ).then(function (response) {
                    that.validHash = true;
                }).catch(function (error) {
                    that.validHash = false;
                }).finally(function () {
                    that.checkingHash = false;
                });
            },
            resetPassword() {
                var that = this;
                that.error = false;
                that.sendingRequest = true;
                axios.post(process.env.VUE_APP_API_URL + "/users/reset/" + that.hash,
                    {"password": that.password},
                    that.apiHeaders
                ).then(function (response) {
                    that.success = true;
                    that.$router.push({path: '/'});
                }).catch(function (error) {
                    that.success = false;
                    that.error = true;
                }).finally(function () {
                    that.sendingRequest = false;
                });
            }
        }
    }

</script>

<style>

    .eda-reset__heading {
        font-weight: 600;
    }

    .eda-reset {
        display: flex;
        padding-top: 4vw;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 1.1em;
        color: white;
    }

    .eda-reset__submit {
        max-width: 20em;
        width: 100%;
    }

    .eda-reset__password {

        width: 20em;
        padding: 1em 0.5em;
    }

    .eda-reset__retry {
        padding-top: 2em;
    }

    .eda-reset__description {
        padding: 0.5em 0 1em 0;
    }

    .eda-reset__submit {
        display: flex;
        justify-content: center;
        padding: 2em 0 2em 0;
    }

    .eda-reset__button {
        text-align: center;
        color: white;
        font-size: 1em;
        background-color: #00B27C;
    }


</style>